import { createApi } from '@reduxjs/toolkit/query/react'
import { authenticatedBaseQuery } from './baseQuery'

export const bannerApi = createApi({
  reducerPath: 'bannerApi',
  baseQuery: authenticatedBaseQuery,
  tagTypes: ['Banner'],
  endpoints: (builder) => ({
    getAllBanners: builder.query({
      query: () => 'product/banners/',
      providesTags: ['Banner'],
    }),
    createBanner: builder.mutation({
      query: (formData) => ({
        url: 'product/banners/',
        method: 'POST',
        body: formData,
      }),
      invalidatesTags: ['Banner'],
    }),
    updateBanner: builder.mutation({
      query: ({ data, id }) => ({
        url: `product/banners/${id}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['Banner'],
    }),
    deleteBanner: builder.mutation({
      query: (id) => ({
        url: `product/banners/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Banner'],
    }),
  }),
})

export const {
  useGetAllBannersQuery,
  useCreateBannerMutation,
  useUpdateBannerMutation,
  useDeleteBannerMutation,
} = bannerApi
